var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogleBw = function SvgGoogleBw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-bw_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0,
    d: "M2 2h20v20H2z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#google-bw_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12.23c0-.71-.06-1.39-.18-2.05H12v3.87h5.38a4.6 4.6 0 0 1-2 3.02v2.51h3.23c1.89-1.74 2.98-4.3 2.98-7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c2.7 0 4.96-.9 6.62-2.42l-3.23-2.51c-.9.6-2.04.95-3.39.95-2.6 0-4.81-1.76-5.6-4.12H3.06v2.59C4.71 19.76 8.09 22 12 22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.4 13.9c-.2-.6-.31-1.24-.31-1.9s.11-1.3.31-1.9V7.51H3.06C2.38 8.86 2 10.39 2 12s.39 3.14 1.06 4.49z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.98c1.47 0 2.79.5 3.82 1.5l2.87-2.87c-1.73-1.61-4-2.6-6.69-2.6-3.91 0-7.29 2.24-8.94 5.51l3.34 2.59c.79-2.36 2.99-4.12 5.6-4.12Z"
  }))));
};
export default SvgGoogleBw;